import type {BaseValidationBagResponse} from '@/api/models';

export class ValidationError extends Error {
    constructor(public errors: BaseValidationBagResponse) {
        super('Validation failure');
        this.name = 'ValidationError';
    }
}
